// src/hooks/useNoindex.js
import { useEffect } from 'react';

/**
 * Ставит <meta name="robots" content="noindex, follow"> на время жизни компонента.
 * Использовать на страницах, которые не должны попадать в индекс,
 * но ссылки с которых обходить нужно (например, /search — уже используется).
 */
export function useNoindex() {
    useEffect(() => {
        let robots = document.querySelector('meta[name="robots"]');
        const created = !robots;
        const prev = robots ? robots.getAttribute('content') : null;

        if (!robots) {
            robots = document.createElement('meta');
            robots.setAttribute('name', 'robots');
            document.head.appendChild(robots);
        }
        robots.setAttribute('content', 'noindex, follow');

        return () => {
            if (created) {
                robots.remove();
            } else if (prev !== null) {
                robots.setAttribute('content', prev);
            }
        };
    }, []);
}

/**
 * Жёсткий вариант: noindex, nofollow. Для приватных страниц
 * (личный кабинет, админка, авторизация), где не нужно ни индексировать,
 * ни передавать вес по ссылкам.
 */
export function useNoindexNofollow() {
    useEffect(() => {
        const robots = document.createElement('meta');
        robots.setAttribute('name', 'robots');
        robots.setAttribute('content', 'noindex, nofollow');
        robots.setAttribute('data-ps-temporary', '1');
        document.head.appendChild(robots);
        return () => robots.remove();
    }, []);
}